<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama", "AltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Riskler: [],
      RiskDegerler: [],
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi: [],
      donem_yili: "",
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId() {
      this.Get();
    },
  },

  methods: {
    Get() {
      this.bugun = new Date();
      //alert(this.bugun);

      this.ActionsGet({
        Service: "StrPerfDonem/" + this.AltDonemId,
        Page: this.Page,
      }).then((res2) => {
        this.donem_yili = res2.Data.YilBas;
      });

      let Filter = "&Donemid=" + this.AltDonemId;

      if (this.BirimId != null && this.BirimId != "") {
        Filter = Filter + "&BirimId=" + this.BirimId;
      }

      this.ActionsFilterGet({
        Service: "StrRaporlama/GetOnemDerecesineGore",
        Page: this.Page,
        Filter: Filter,
      }).then((res3) => {
        let girilendegerler = [];
        this.RiskDegerler = [];

        for (var i = 0; i < res3.Data.length; i++) {
          var varmi = girilendegerler.indexOf(res3.Data[i].Riskid);

          if (varmi < 0) {
            girilendegerler.push(res3.Data[i].Riskid);
          }
        }

        for (i = 0; i < girilendegerler.length; i++) {
          var sayac = 0;
          var toplametki = 0;
          var toplamolasilik = 0;
          let hesaplanan = [];
          for (var s = 0; s < res3.Data.length; s++) {
            if (res3.Data[s].Riskid == girilendegerler[i]) {
              sayac = sayac + 1;
              toplametki = toplametki + res3.Data[s].Etki;
              toplamolasilik = toplamolasilik + res3.Data[s].Olasilik;
              if (sayac == 1) {
                hesaplanan.push(res3.Data[s]);
              }
            }
          }
          hesaplanan[0].Riskpuani =
            Math.round(toplametki / sayac) * Math.round(toplamolasilik / sayac);

          this.RiskDegerler.push(hesaplanan[0]);
        }

        this.RiskDegerler.sort(this.buyuktenKucugeSiralama);
      });
    },

    buyuktenKucugeSiralama(a, b) {
      return b.Riskpuani - a.Riskpuani;
    },

    // Renklendirme fonksiyonu
    renk(Data, Kategori) {
      if (Kategori == "10luk Puan") {
        if (Data > 0 && Data <= 25) {
          return "green"; // Düşük risk için sarı
        }
        if (Data > 25 && Data <= 64) {
          return "yellow"; // Orta risk için yeşil
        }
        if (Data > 64) {
          return "red"; // Yüksek risk için kırmızı
        }
      } else {
        if (Data > 19 && Data <= 25) {
          return "#800000"; // 5lik çok yüksek için
        }
        if (Data >= 12 && Data < 20) {
          return "red"; // yüksek 
        }
        if (Data >= 6 && Data < 12) {
          return "orange"; // orta 
        }
        if (Data >= 3 && Data < 6) {
          return "yellow"; // Düşük 
        }
        if (Data > 3) {
          return "green"; // çok düşük
        }
      }
    },

    // Değerlendirme fonksiyonu
    degerlendirme(Data) {
      var risk = "";
      if (Data > 0 && Data <= 25) {
        risk = "Düşük Risk";
      } else if (Data > 25 && Data <= 64) {
        risk = "Orta Risk";
      } else if (Data > 64) {
        risk = "Yüksek Risk";
      }
      return risk;
    },

    // Excel export fonksiyonu
    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.riskonemraporu;
      var html = table.innerHTML;
      var ctx = { worksheet: name || "Worksheet", table: html };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },
  },

  created() {
    this.Get();
  },
};
</script>

<template>
  <div>
    <div class="text-sm-end">
      <button
        type="button"
        class="btn btn-success btn-rounded mb-2 me-2"
        @click="
          ExcelExport(
            'Risk Raporu Önem Derecesine Göre',
            'Risk Raporu Önem Derecesine Göre'
          )
        "
      >
        <i class="mdi mdi-file-export-outline me-1"></i>
        Excel'e Aktar
      </button>
    </div>

    <div ref="riskonemraporu" class="table-responsive">
      <div class="table-responsive">
        <table style="width:100%">
          <tr>
            <td colspan="4" style="text-align: center;">
              <div><h4>Önem Derecelerine Göre Risk Listesi</h4></div>
            </td>
          </tr>
          <tr>
            <td colspan="4" style="text-align: center;">
              <div>
                <h4>{{ donem_yili }} Risk Yönetimi</h4>
              </div>
            </td>
          </tr>
        </table>

        <br />

        <table
          style="border: 1px solid; border-collapse: collapse;"
          border="1"
          class="table table-md table-bordered border-success mb-0"
        >
          <thead class="table-light" style="text-align: center;">
            <tr style="text-align: center; font-weight: bold;">
              <th>Sıra</th>
              <th>Risk</th>
              <th>Risk Birimi</th>
              <th>Risk Puanı</th>
              <th>Değerlendirme</th>
            </tr>
          </thead>
          <tbody v-for="(Data, index) in RiskDegerler" :key="index">
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{ Data.StrRisk }}</td>
              <td>{{ Data.Birimadi }}</td>
              <td
                class="text-center"
                :style="{
                  background: renk(
                    Math.round(Data.Riskpuani),
                    Data.Riskkategori
                  ),
                }"
                style="text-align: center;"
              >
                <span style="color: black">{{
                  Math.round(Data.Riskpuani)
                }}</span>
              </td>
              <td>{{ degerlendirme(Math.round(Data.Riskpuani)) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
